/*

class to generate provider qualification

https://www.hl7.org/fhir/practitioner-definitions.html#Practitioner.qualification

{
  "code" : { code }, // R!  Coded representation of the qualification
  "period" : { Period }, // Period during which the qualification is valid
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { identifiers, joiValidateObj } = require('../datastructComponents');
const { codeSchema } = require('./code.class');
const { referenceSchema } = require('./reference.class');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  userId: Joi.string().required(),
  qualificationId: Joi.string().required(),
  code: Joi.object().keys( codeSchema ).required(),
  periodStart: Joi.string().optional(),
  periodEnd: Joi.string().optional(),
  issuer: Joi.object().keys( referenceSchema ).optional(),
};

// Define class
class UserQualification extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.userQualification.buildPk(obj.userId),
      identifiers.userQualification.buildSk(obj.state, obj.userType, obj.userId, obj.qualificationId)
    );
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.UserQualification = UserQualification;
exports.userQualificationSchema = schema;